import React, {createContext, useState} from 'react';
import {API} from 'aws-amplify';
import { EmbedTokenInterface } from '../models/EmbedTokenInterface';
import { useApiError } from './ApiErrorProvider';
import { error } from '../constants/bindings';

const TokenContext = createContext({ loading: true, embedToken: {} as EmbedTokenInterface, getEmbedToken: ()=>{}});

export const PBIProvider = (props) => {

    const {setErrorCode} = useApiError();
    const [embedToken, setEmbedToken] = useState({} as EmbedTokenInterface);
    const [loading, setLoading] = useState(true as boolean);
 
    const getEmbedToken = async () => {

        setLoading(true);
        try {
            const tokenData = await API.get('crewlife', `/api/GenerateEmbedToken`,{});
            setEmbedToken(tokenData);
            setLoading(false);
            return tokenData
        } catch (e:any) {
            setLoading(false);
            if( e.response?.status) { setErrorCode(e.response?.status); }
            else {
                setErrorCode(error.DEFAULT);
                return null;
            }
        }
    }

    return (
        <TokenContext.Provider value={{ embedToken, loading, getEmbedToken }}>
            {props.children}
        </TokenContext.Provider>
    )
}

export const usePbi = () => {
    return React.useContext(TokenContext);
}
